import * as S from './style';
import sideImage from '../../assets/side-section.png';
import logo from '../../assets/logo-navy.png';
import useMediaQuery from '@mui/system/useMediaQuery';
import { breakpoints } from '../../../theme';

interface SideLayoutProps {
  children: React.ReactNode;
}

const SideLayout = ({ children }: SideLayoutProps) => {
  const isWideScreen = useMediaQuery(`(min-width:${breakpoints.tablet}px)`);

  return (
    <>
      <S.LayoutContainer container>
        {!isWideScreen && (
          <S.LogoContainer>
            <S.Logo src={logo} width={118} height={48} alt="smf-logo" />
          </S.LogoContainer>
        )}
        <S.InnerContent>{children}</S.InnerContent>
        <S.SideGraphicDiv item background={sideImage} />
      </S.LayoutContainer>
    </>
  );
};

export default SideLayout;
